class HeurekaOptout extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.loadingOverlay = this.querySelector('.loading-overlay');
    this.errorElement = this.querySelector('.heureka-optout__error');
    if (!this.checkbox) return;

    // Bez atributu na košíku by Feedyio nemělo podle čeho poznat souhlas,
    // proto se výchozí hodnota zapíše hned při prvním zobrazení košíku.
    // Chybu tohoto zápisu na pozadí zákazníkovi nehlásíme.
    if (!this.dataset.currentValue) {
      this.updateConsent(true);
    }

    this.checkbox.addEventListener('change', () => this.updateConsent());
  }

  updateConsent(silent) {
    const value = this.checkbox.checked ? this.dataset.valueRefused : this.dataset.valueAccepted;
    const attributes = {};
    attributes[this.dataset.attributeKey] = value;

    this.checkbox.disabled = true;
    if (this.loadingOverlay) this.loadingOverlay.classList.remove('hidden');

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify({ attributes }) })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
        this.dataset.currentValue = value;
        this.toggleError(false);
      })
      .catch(() => {
        // Zákazník musí vidět skutečný stav uložený v košíku, ne ten, který se nepodařilo uložit.
        this.checkbox.checked = this.dataset.currentValue === this.dataset.valueRefused;
        this.toggleError(!silent);
      })
      .finally(() => {
        this.checkbox.disabled = false;
        if (this.loadingOverlay) this.loadingOverlay.classList.add('hidden');
      });
  }

  toggleError(show) {
    if (!this.errorElement) return;
    this.errorElement.textContent = show ? theme.cartStrings.error : '';
    this.errorElement.classList.toggle('hidden', !show);
  }
}
customElements.define('heureka-optout', HeurekaOptout);
